// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useAuthSession } from "./hooks/useAuthSession";
import Login from "./components/Login";
import DashboardList from "./components/DashboardList";
import DashboardFullscreen from "./components/DashboardFullscreen";

function App() {
  const { session, loading, expiredLink, recoveryEmail } = useAuthSession();

  if (loading) return <div>Loading…</div>;

  return (
    <Router>
      <Routes>

        {/* Magic Link Callback (REQUIRED for Supabase auth) */}
        <Route
          path="/auth/callback"
          element={
            session
              ? <Navigate to="/dashboard" replace />
              : <Login initialEmail={expiredLink ? recoveryEmail : ""} expired={expiredLink} />
          }
        />

        {/* Login */}
        <Route
          path="/login"
          element={
            session
              ? <Navigate to="/dashboard" replace />
              : <Login initialEmail={expiredLink ? recoveryEmail : ""} expired={expiredLink} />
          }
        />

        {/* Dashboard list */}
        <Route
          path="/dashboard"
          element={
            session
              ? <DashboardList session={session} />
              : <Navigate to="/login" replace />
          }
        />

        {/* Fullscreen dashboard */}
        <Route
          path="/dashboard/view"
          element={
            session
              ? <DashboardFullscreen session={session} />
              : <Navigate to="/login" replace />
          }
        />

        {/* Default */}
        <Route
          path="/"
          element={
            session
              ? <Navigate to="/dashboard" replace />
              : <Navigate to="/login" replace />
          }
        />

      </Routes>
    </Router>
  );
}

export default App;
